import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flex: 'auto 1 auto',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 30,
      marginBottom: 20,
    },
    dividerText: {
      whiteSpace: 'nowrap',
      padding: 10,
      paddingLeft: 15,
      paddingRight: 15,
      textAlign: 'center',
      backgroundColor: theme.palette.divider,
      borderRadius: theme.shape.borderRadius * 2,
    },
  }))

export default useStyles
